import * as yup from 'yup';

export type BulkUploadStatus = 'queued' | 'processing' | 'completed' | 'failed';

export const bulkUploadTemplatesSchema = yup.object({
  token: yup.string().required(),
  templateKey: yup.string().required(),
  webhookKey: yup.string().required(),
  clientId: yup.string().required(),
});

export type IBulkUploadTemplates = yup.InferType<typeof bulkUploadTemplatesSchema>;

export const bulkUploadStatusSchema = yup.object({
  id: yup.string().required(),
  status: yup.mixed<BulkUploadStatus>().required(),
  listId: yup.string().required(),
  entityType: yup.mixed<'company' | 'person'>().required(),
  totalRecords: yup.number().required(),
  processedRecords: yup.number().required(),
  skippedRecords: yup.number().required(),
  failedRecords: yup.number().required(),
  errorMessage: yup.string().nullable().defined(),
  createdAt: yup.string().required(),
  updatedAt: yup.string().required(),
});

export type IBulkUploadStatus = yup.InferType<typeof bulkUploadStatusSchema>;

export function isTerminalStatus(status: BulkUploadStatus): boolean {
  return status === 'completed' || status === 'failed';
}
